import { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { execSeatableSql } from './seatable.js';

import NavHeader from './navheader.js';
import Hero from './hero.js';
import Stats from './stats.js';
import AI from './ai.js';
import Services from './services.js';
import Segments from './segments.js';
import Artifacts from './artifacts.js';
import Clients from './clients.js';
import Quotes from './quotes.js';
import TechStack from './techstack.js';
import Leaders from './leaders.js';
import DomainTopics from './domaintopics.js';
import Footer from './footer.js';

function Capabilities() {
    const { capability } = useParams();
    // const [data, setData] = useState(null);
    const [capabilityDesc, setCapabilityDesc] = useState('');
    
    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT \`Desc\` FROM Capability WHERE \`ShortDesc\` = '${capability}'`;
        // setData(null);
        setCapabilityDesc('');
        
        try {
          const rows = await execSeatableSql(sql);
          // setData(rows && rows.results[0]);
          setCapabilityDesc(rows && rows.results[0]["Desc"]);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [capability]);

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            if (location.hash.substring(1) === 'top') {
                window.scrollTo({ top: 0, behavior: 'smooth'})
            } else {
                const element = document.getElementById(location.hash.substring(1));
                if (element) {
                    element.scrollMargin = -50;
                    element.scrollIntoView({ block: 'start', behavior: 'smooth' });
                }
            }
        }
    }, [location]);

    return (
        <div>
            <NavHeader mode="Capability" capability={capabilityDesc} navBrand={capability} />
            <Hero capability={capabilityDesc} />
            <Stats capability={capabilityDesc} />
            <AI capability={capabilityDesc} />
            <Services capability={capabilityDesc} />
            <Segments capability={capabilityDesc} />
            <Artifacts capability={capabilityDesc} />
            <Clients capability={capabilityDesc} />
            <Quotes capability={capabilityDesc} />
            <TechStack capability={capabilityDesc} />
            <Leaders capability={capabilityDesc} />
            <DomainTopics capability={capabilityDesc} />
            <Footer />
        </div>
    )
}

export default Capabilities;